// French texts (default language), from Joe's wording-fr.md. Missing keys fall back to en.js.
export default {
  "meta": {
    "title": "Gilbert Trinidad, Product Designer / Builder",
    "description": "Product designer / builder à Paris. Je conçois des produits web et je les mets en ligne en dirigeant Claude Code."
  },
  "nav": {
    "projects": "Projets",
    "contact": "Me contacter",
    "about": "À propos",
    "cv": "CV",
    "homeLabel": "Gilbert Trinidad, accueil",
    "services": "Services",
    "openMenu": "Ouvrir le menu",
    "closeMenu": "Fermer le menu",
    "menu": "Menu",
    "downloadCv": "Télécharger mon CV",
    "bookCall": "Réserver un appel gratuit"
  },
  "lang": {
    "fr": "Français",
    "en": "English"
  },
  "hero": {
    "hello": "Bonjour, je suis",
    "title": "Product Designer",
    "text": "Je conçois des produits web et je les mets en ligne avec une équipe d'agents Claude que j'ai créée. Je mène la recherche et les décisions de design, je dirige l'IA et je vérifie chaque livrable.",
    "seeWork": "Voir mes projets",
    "contact": "Me contacter",
    "book": "Réserver un appel gratuit de 30 min",
    "talk": "Parlons de votre projet",
    "trusted": "Ils m'ont fait confiance : coachs et thérapeutes à Paris",
    "mockupAlt": "Site SPCoach, version ordinateur et mobile",
    "available": "Ouvert à un poste de Product Designer · Paris",
    "h1a": "Bonjour, je suis Gilbert,",
    "h1b": "Product Designer / Builder",
    "chips": {
      "research": "Recherche UX",
      "wireframes": "Wireframes",
      "prototyping": "Prototype en code",
      "ui": "Design system",
      "ai": "Claude Code",
      "launch": "Mise en ligne"
    }
  },
  "work": {
    "title": "Projets sélectionnés",
    "intro": "Deux sites de coachs que j'ai conçus, et deux plateformes : un concept et un produit client."
  },
  "testimonials": {
    "title": "Ce qu'en disent mes clientes",
    "seeProject": "Voir le projet →",
    "sophie": {
      "job": "Coach et thérapeute",
      "quote": "Gilbert a conçu mon site et en a écrit les textes. Il a pris le temps de comprendre mes accompagnements et mes clients, souvent anxieux à l'idée de faire le premier pas. Le résultat est un site chaleureux et clair, qui me ressemble et qui permet de réserver une séance facilement.",
      "pullStart": "« Un site chaleureux et clair, ",
      "pullEnd": "qui me ressemble",
      "pullAfter": ". »"
    },
    "melodie": {
      "job": "Consultante en bilan de compétences et psychopraticienne",
      "quote": "Mes deux accompagnements, le bilan de compétences et la thérapie, sont très différents. Gilbert l'a tout de suite compris et a donné à chacun un parcours clair, avec des mots qui restent doux, comme ma pratique. Aujourd'hui, mes visiteurs trouvent le bon accompagnement et réservent facilement un rendez-vous découverte.",
      "pullStart": "« Mes visiteurs ",
      "pullEnd": "trouvent le bon accompagnement",
      "pullAfter": ". »"
    },
    "subtitle": "Deux coachs parisiennes racontent comment nous avons conçu leur site ensemble."
  },
  "skills": {
    "count": "Temps",
    "title": "Ce que je fais",
    "ux": {
      "step": "Écouter",
      "name": "Comprendre et décider",
      "description": "Je pars des utilisateurs : qui ils sont, ce qui les freine, ce dont ils ont besoin. Puis je tranche entre les options et je construis un parcours qui les aide pas à pas, pour que l'étape suivante soit toujours évidente.",
      "tags": "Recherche UX | Parcours | Arbitrages"
    },
    "ui": {
      "step": "Imaginer la choré",
      "name": "Concevoir le système",
      "description": "Je pilote Claude connecté à Figma : il génère les wireframes, les maquettes et les prototypes directement dans Figma, sur un design system tenu à jour pour que chaque écran trouve le bon rythme.",
      "tags": "Design system | Claude + Figma | Wireframes | Prototypes"
    },
    "proto": {
      "step": "Entrer dans le cercle",
      "name": "Faire tester les prototypes",
      "description": "Je fais tester mes prototypes à de vrais utilisateurs, en visio ou par un simple lien : le prototype s'ouvre directement sur un site, sans rien à installer. J'observe où ils hésitent et j'ajuste avant de développer. La réaction du cercle me dit si le parcours tient.",
      "tags": "Tests utilisateurs | Prototypes Figma | Zoom | Itérations"
    },
    "test": {
      "step": "Répéter",
      "name": "Tester et ajuster",
      "description": "Je définis ce qu'il faut vérifier, et mes agents QA et accessibilité le contrôlent : liens, traductions FR/EN, contrastes, navigation au clavier. Je relis chaque point sur mobile et sur ordinateur, puis je tranche ce qui doit être corrigé avant la mise en ligne.",
      "tags": "QA | Accessibilité | Agents Claude | Revue mobile"
    },
    "dev": {
      "step": "Monter sur scène",
      "name": "Automatiser la production",
      "description": "Claude Code développe ce que je conçois. Je fixe la direction, je suis chaque changement de près et rien ne part en ligne sans ma validation : un bon suivi aboutit à une bonne mise en scène.",
      "tags": "Claude Code | Agents IA | Vue / Tailwind | Vercel"
    },
    "subtitle": "Du problème jusqu'au produit en ligne : je décide, l'IA accélère, je vérifie tout.",
    "tools": "Mes outils :"
  },
  "about": {
    "title": "À propos",
    "p2": "Ma méthode : comprendre les utilisateurs, rendre l'offre facile à saisir et supprimer tout ce qui ralentit la décision. Je montre mes choix et ce que j'ai écarté, pas seulement le résultat.",
    "cv": "Télécharger mon CV",
    "p1Start": "Je suis Gilbert, ",
    "p1Highlight": "product designer",
    "p1End": " à Paris, avec un passé de développeur web. Je crée moi-même mon workflow et mes agents Claude, une petite équipe produit : recherche, design, rédaction, code et tests. C'est moi qui mène la danse : je fixe la direction, je tranche et je vérifie chaque livrable avant qu'il parte en ligne.",
    "cta": "Me contacter",
    "chip1": "Design + rédaction",
    "chip2": "Du problème au produit en ligne"
  },
  "case": {
    "resultLabel": "Résultat",
    "contactTitle": "Envie d'en parler ?",
    "contactText": "Je vous explique mes choix et ce que j'ai écarté sur ce projet.",
    "nextLabel": "Projet suivant",
    "client": "Client :",
    "role": "Rôle :",
    "tools": "Outils :",
    "goTo": "Voir {name}",
    "sections": {
      "context": "Contexte",
      "challenge": "L'enjeu",
      "approach": "Approche",
      "solution": "Solution",
      "outcome": "Résultat",
      "decisions": "Décisions et compromis",
      "retro": "Avec le recul"
    },
    "back": "Retour",
    "atAGlance": "En bref",
    "clientLabel": "Client",
    "roleLabel": "Rôle",
    "typeLabel": "Type",
    "toolsLabel": "Outils",
    "contents": "Sommaire",
    "similarTitle": "Un projet similaire ?",
    "similarText": "Parlons de votre site lors d'un premier appel gratuit de 30 minutes.",
    "similarCta": "Réserver un appel"
  },
  "projects": {
    "1": {
      "label": "Projet client",
      "hook": "Le site d'une coach parisienne : de la première visite à la séance réservée",
      "tagline": "Un site créé de zéro, grâce auquel des clients contactent Sophie",
      "result": "Des clients contactent Sophie via le site",
      "client": "Sophie Pratt, coach et thérapeute, Paris",
      "role": "UX/UI design dans Figma et rédaction des textes",
      "tools": "Figma",
      "visit_label": "Voir spcoach.fr",
      "sections": {
        "context": "Sophie propose du coaching personnel, du coaching en entreprise et une thérapie de la phobie sociale, à Paris et en ligne. Elle n'avait pas encore de site internet. Beaucoup de ses futurs clients appréhendent le premier pas : le site devait d'abord inspirer confiance avant de vendre quoi que ce soit.",
        "challenge": "Trois offres, trois publics, et des visiteurs qui hésitent à la contacter. Ils devaient comprendre rapidement ce que fait Sophie, si c'est pour eux, comment ça se passe et combien ça coûte, sans se sentir poussés.",
        "decisions": "1. Un appel découverte gratuit de 30 minutes. Pour des visiteurs qui appréhendent le premier pas, un échange sans engagement est plus facile à franchir qu'une séance payante.\n2. Le forfait de 8 séances mis en avant. Il est signalé comme l'offre populaire et l'économie est affichée, pour guider vers l'accompagnement complet sans cacher la séance à l'unité.\n3. Une structure qui suit les questions du visiteur : qu'est-ce que c'est, est-ce pour moi, comment ça marche, combien ça coûte, qui est-elle. J'ai écrit les textes en même temps que la structure, avec la participation de Sophie, et la FAQ et les gages de confiance (Sorbonne, Qualiopi) complètent le parcours.\n4. Des maquettes prêtes pour le développement. J'ai conçu le site dans Figma, et un développeur l'a construit sous WordPress à partir de mes maquettes.",
        "outcome": "Le site est en ligne et Sophie l'utilise pour présenter ses offres et prendre ses rendez-vous. Des clients l'ont contactée grâce au site. Comme elle le dit : « Le résultat est un site chaleureux et clair, qui me ressemble et qui permet de réserver une séance facilement. »",
        "retro": "Je n'ai pas utilisé l'IA sur ce projet. Aujourd'hui, je referais tout avec Claude, de la conception jusqu'à la mise en ligne."
      },
      "type": "Site vitrine · Réservation",
      "screens": {
        "intro": {
          "title": "Introduction"
        },
        "pricing": {
          "title": "Mes tarifs"
        },
        "confirmation": {
          "title": "Page de confirmation"
        }
      }
    },
    "2": {
      "label": "Projet client",
      "hook": "Deux accompagnements, un seul chemin clair vers le rendez-vous découverte",
      "tagline": "Un site créé de zéro, qui donne envie aux visiteurs de contacter Mélodie",
      "result": "Des clients contactent Mélodie via le site",
      "client": "Mélodie Yeremian, consultante en bilan de compétences et psychopraticienne, à Paris et à distance",
      "role": "Design dans Figma et création du site (WordPress, Divi)",
      "tools": "Figma, WordPress, Divi Builder, Claude",
      "visit_label": "Voir melodieyeremian.com",
      "sections": {
        "context": "Mélodie accompagne les personnes dans leurs transitions professionnelles et personnelles, avec deux accompagnements distincts : le bilan de compétences et l'accompagnement thérapeutique. Elle n'avait pas encore de site internet : tout partait de zéro.",
        "challenge": "Les deux accompagnements répondent à des besoins très différents. Les visiteurs devaient trouver rapidement le leur, sans confondre bilan et thérapie, et se sentir assez en confiance pour réserver un premier rendez-vous. Deux contraintes cadraient le projet : Mélodie devait pouvoir modifier son site seule, et le ton devait rester doux, fidèle à sa pratique.",
        "decisions": "1. Deux parcours séparés plutôt qu'une page commune. Chaque accompagnement a sa page, ses détails et sa propre réservation découverte.\n2. WordPress et Divi Builder plutôt qu'un site codé sur mesure. J'ai privilégié l'autonomie de Mélodie, en acceptant moins de liberté dans les détails d'interface.\n3. Traduire les demandes de la cliente en interface. La barre « Prendre RDV » toujours visible, un bouton découverte propre à chaque offre et une boutique discrète venaient de Mélodie. Mon rôle a été de les intégrer sans alourdir le parcours.\n4. Une section « Qui suis-je » personnelle, parce qu'en thérapie comme en bilan, on choisit d'abord une personne.",
        "outcome": "Le site est en ligne et Mélodie l'utilise pour présenter ses deux accompagnements et prendre ses rendez-vous. Depuis la mise en ligne, des clientes l'ont contactée après avoir découvert son site. Comme elle le dit : « Aujourd'hui, mes visiteurs trouvent le bon accompagnement et réservent facilement un rendez-vous découverte. »",
        "retro": "Je n'ai pas utilisé l'IA pour créer ce site. Aujourd'hui, je commencerais directement avec Claude plutôt que d'installer et de configurer WordPress à la main. J'ai donc créé un workflow qui relie le site à Claude : les prochaines modifications sur WordPress, Divi et les plugins se feront en le demandant à Claude, sans passer par l'administration WordPress. Il est prêt et en cours d'installation sur le compte Claude de Mélodie, pour qu'elle gère son site en autonomie."
      },
      "type": "Site vitrine · Boutique",
      "screens": {
        "services": {
          "title": "Prestations"
        },
        "pricing": {
          "title": "Tarifs"
        },
        "shop": {
          "title": "Boutique"
        }
      }
    },
    "3": {
      "label": "Projet conceptuel",
      "hook": "Plateforme de réservation d'hébergements insolites",
      "description": "Atypikhouse est le concept d'une plateforme de location dédiée aux séjours insolites. J'ai conçu l'expérience sur ordinateur et mobile pour aider chacun à trouver une escapade au calme et à la réserver facilement.",
      "type": "Plateforme web & mobile",
      "screens": {
        "homeDesktop": {
          "title": "Accueil sur ordinateur"
        },
        "homeMobile": {
          "title": "Accueil sur mobile"
        }
      }
    },
    "4": {
      "label": "Projet client",
      "hook": "Plateforme de formation avec des cours payés en cryptomonnaie",
      "description": "Unfate est une plateforme de formation née d'une idée simple : tout ce qu'il faut savoir sur un sujet, au même endroit, sans avoir à chercher des morceaux partout sur le web. Les cours se paient en cryptomonnaie. Avec l'équipe fondatrice, j'ai conçu les parcours principaux : connexion, paramètres, entraînement et examens. Le produit a depuis été arrêté.",
      "type": "Application web",
      "screens": {
        "login": {
          "title": "Connexion"
        },
        "settings": {
          "title": "Paramètres"
        },
        "practice": {
          "title": "Entraînement"
        },
        "examInstructions": {
          "title": "Consignes d'examen"
        },
        "nextQuestion": {
          "title": "Question suivante"
        },
        "examPassed": {
          "title": "Examen réussi"
        }
      }
    }
  },
  "contact": {
    "title": "Échangeons",
    "subtitle": "Vous recrutez un product designer ? Écrivez-moi, je vous réponds rapidement.",
    "preferTalk": "Vous préférez en parler ? Réservez un appel gratuit de 30 min",
    "or": "ou envoyez-moi un message",
    "name": "Nom",
    "email": "Email",
    "message": "Votre message",
    "send": "Envoyer le message",
    "sending": "Envoi…",
    "success": "Merci ! Je vous réponds sous 48 h.",
    "errorBefore": "Une erreur est survenue. Réessayez ou écrivez-moi sur",
    "privacyNote": "Vos coordonnées servent uniquement à vous répondre.",
    "privacy": "Politique de confidentialité",
    "copyright": "© 2026 Gilbert Trinidad"
  },
  "privacy": {
    "title": "Politique de confidentialité",
    "text": "Ce site ne dépose aucun cookie publicitaire. Les informations envoyées via le formulaire de contact (nom, email, message) servent uniquement à vous répondre et ne sont jamais transmises à des tiers."
  },
  "strip": {
    "alt": "Projet {name}, écran {screen}",
    "label": "Écrans de projets",
    "screens": {
      "pricing": "tarifs",
      "confirmation": "confirmation",
      "services": "prestations",
      "shop": "boutique",
      "home": "accueil"
    }
  },
  "gallery": {
    "title": "Les écrans",
    "hint": "Cliquez sur un écran pour l'agrandir",
    "open": "Agrandir : {title}"
  },
  "viewer": {
    "close": "Fermer",
    "previous": "Écran précédent",
    "next": "Écran suivant",
    "scrollHint": "Faites défiler pour voir toute la page",
    "work": "Travail"
  },
  "notFound": {
    "title": "Page introuvable",
    "text": "Cette page n'existe pas ou a été déplacée.",
    "projects": "Voir mes projets",
    "home": "Retour à l'accueil"
  }
}
